import React from "react";

/* ======================================================================== */
/* Helpers UI                                                                */
/* ======================================================================== */
export function Field({ label, required, children }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-widest text-gray-500 mb-1 font-semibold">
        {label} {required && <span className="text-destructive">*</span>}
      </label>
      {children}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle }) {
  return (
    <div className="bg-white border border-dashed border-gray-300 rounded-sm py-16 px-6 text-center">
      <Icon className="h-10 w-10 text-gray-300 mx-auto mb-3" />
      <h3 className="font-serif text-lg text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-600 max-w-md mx-auto">{subtitle}</p>
    </div>
  );
}

export function SkeletonGrid() {
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="bg-gray-100 animate-pulse h-40 rounded-sm" />
      ))}
    </div>
  );
}
